export const YES_NO = 1;
export const MULTIPLE = 2;
export const RANK = 3;
export const OPEN = 4;

export const MAX_TITLE_LENGTH = 100;
export const MAX_DESCRIPTION_LENGTH = 600;

export const MAX_NUMBER_MULTIPLE_QUESTION = 6;
export const MAX_MULTIPLE_QUESTION_LENGTH = 40;

export const MAX_REVIEW_DESCRIPTION_LENGTH = 300;
